import Dashboard from './pages/Dashboard';
import { CssBaseline } from '@mui/material';

function App() {
  return (
    <>
      <CssBaseline />
      <Dashboard />
    </>
  );
}

export default App;